import * as React from "react";
import { Row, Col, Input } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "Components/General/Button";
import { I18N_NS } from "Config/i18n";
import { withTranslation, WithTranslation } from "react-i18next";
import classNames from "classnames";

interface MetadataRangeListProps extends WithTranslation {
  value?: API_MetadataValueRange[];
  onChange?: (value: API_MetadataValueRange[]) => void;
  readOnly?: boolean;
}

export const MetadataRangeList = withTranslation(I18N_NS.ADMIN)(
  ({ t, value = [], onChange, readOnly }: MetadataRangeListProps) => {
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
      const copy = value.slice();
      copy[index][e.target.dataset.id] = e.target.value;
      onChange(copy);
    };

    const handleRemove = (idx: number) => {
      const copy = value.slice();
      copy.splice(idx, 1);
      onChange(copy);
    };

    const handleAdd = () => {
      onChange(value.concat({ value: "", description: "" }));
    };

    return (
      <div>
        {value.map((item, idx) => {
          const index = value.findIndex((i) => i.value === item.value);
          return (
            <Row className="mb-2" gutter={10} key={idx}>
              <Col span={11}>
                <Input
                  data-id="value"
                  value={item.value}
                  placeholder={t("Value")}
                  disabled={readOnly}
                  onChange={(e) => handleInputChange(e, idx)}
                  className={classNames({ "bg-error": index !== idx })}
                />
              </Col>
              <Col span={11}>
                <Input
                  data-id="description"
                  value={item.description}
                  placeholder={t("Description")}
                  disabled={readOnly}
                  onChange={(e) => handleInputChange(e, idx)}
                />
              </Col>
              {!readOnly && (
                <Col span={2}>
                  <span style={{ cursor: "pointer" }} onClick={() => handleRemove(idx)}>
                    <FontAwesomeIcon icon={["far", "minus-circle"]} fixedWidth={true} size="lg" />
                  </span>
                </Col>
              )}
            </Row>
          );
        })}
        {!readOnly && (
          <Button faIcon="plus" type="dashed" onClick={handleAdd}>
            {t("Add")}
          </Button>
        )}
      </div>
    );
  }
);
